import React from 'react';

import { useAnalytics } from '@funnels/providers';
import { run } from '@funnels/utils';

import { Container } from './index.style';

interface NewApplicationButtonCardProps {
  handleClick: () => void;
}

const LABEL = 'Start new application';

export default function NewApplicationButtonCard({ handleClick }: NewApplicationButtonCardProps) {
  const { tracking } = useAnalytics();
  return (
    <Container
      variant="empty"
      isDisabled={true}
      onClick={run(handleClick, () => tracking?.button.empty({ text: LABEL }))}
    >
      <strong>+</strong>
      {LABEL}
    </Container>
  );
}
